import { Controller } from "@hotwired/stimulus"
import VueI18n from "vue-i18n"
import Vue from "vue"
const ModuleMap = {}
Vue.use(VueI18n)

export default class extends Controller {
    static values = {component: String, props: Object, translations: Object}
    connect() {
        const messages = {}
        messages[window.languageCode] = {...this.translationsValue}

        const i18n = new VueI18n({ locale: window.languageCode, messages })
        const el = this.element
        const props = this.propsValue
        let component = ModuleMap[this.componentValue]

        let vue = new Vue({ i18n, el, render: h => h(component, { props }) })
        console.log("slim vue binding: " + this.componentValue)
    }
}
